import API from '../services/api';
import { toError } from '../services/apiError';

const api = new API();

const LOAD_USERS_ERROR = 'Failed to load the user list';
const IMPERSONATE_ERROR = 'Failed to start the impersonation session';

export function getAllUsers() {
    return api
        .getJson('api/users', { method: 'GET', cache: true })
        .then(response => {
            if (!response || response.status !== 0) {
                throw toError(response && response.value, LOAD_USERS_ERROR);
            }
            return response.value || [];
        })
        .catch(reason => {
            throw toError(reason, LOAD_USERS_ERROR);
        });
}

export function impersonateUser(userId) {
    return api
        .getJson('api/users/impersonate', { method: 'POST', body: userId })
        .then(response => {
            if (!response || response.status !== 0) {
                throw toError(response && response.value, IMPERSONATE_ERROR);
            }
        })
        .catch(reason => {
            throw toError(reason, IMPERSONATE_ERROR);
        });
}
